export interface MfaScreenLayoutProps {
  variant?: 'default' | 'banner';
  bannerImageDesktop?: string;
  hideLogo?: boolean;
  headerClasses?: string;
}

export const getMfaScreenLayoutProps = ({
  variant = 'default',
  bannerImageDesktop,
  hideLogo = true,
  headerClasses,
}: MfaScreenLayoutProps) =>
  variant === 'banner'
    ? ({
        variant,
        bannerImageDesktop,
        hideLogo,
        headerClasses,
      } as const)
    : ({ variant, hideLogo, headerClasses } as const);
